var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.617,
    height: 20.107,
    viewBox: "0 0 31.617 20.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#fcb316;}.c{fill:#10357f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 31.617,
    height: 20.107,
    rx: 1,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30.555,
    height: 2.737,
    transform: "translate(0.559 16.812)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 30.555,
    height: 2.737,
    transform: "translate(0.559 0.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M175.061,30.212l-3.184,7.54H169.81l-1.564-6.032a.828.828,0,0,0-.447-.67,8.358,8.358,0,0,0-1.9-.614l.056-.223h3.3a.9.9,0,0,1,.894.782l.838,4.357,2.011-5.138Zm8.044,5.083c0-2.011-2.737-2.122-2.737-2.96,0-.279.279-.559.838-.614a3.612,3.612,0,0,1,1.9.335l.335-1.62A5.135,5.135,0,0,0,181.6,30.1c-1.9,0-3.3,1.005-3.3,2.513,0,1.061.95,1.676,1.732,2.067s1.005.614,1.005.949c0,.5-.614.726-1.173.726a5.021,5.021,0,0,1-2.011-.447l-.335,1.676a5.788,5.788,0,0,0,2.179.391c2.067-.112,3.407-1.117,3.407-2.681m5.139,2.458h1.788l-1.564-7.54h-1.676a.915.915,0,0,0-.838.559l-2.9,6.982h2.067l.391-1.117h2.514Zm-2.179-2.681,1.005-2.848.614,2.848Zm-8.211-4.859-1.62,7.54h-1.955l1.62-7.54Z",
    transform: "translate(-162.269 -23.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.c5b90f9d088e1107bec930987a5e0a45.svg";
export { ForwardRef as ReactComponent };